import styled, { css } from 'styled-components';
import { ICON_SIZES } from '../../../../icon';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * ReceiptGroup
 */
export const receiptGroupStyles = ({ theme, $withHorizontalSpacing, }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing[100])};
	padding-top: ${pxToRem(theme.spacing[100])};
	padding-bottom: ${pxToRem(theme.spacing[100])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		padding-top: ${pxToRem(theme.spacing[200])};
		padding-bottom: ${pxToRem(theme.spacing[200])};
	}

	${$withHorizontalSpacing === true &&
    css `
		padding-left: ${pxToRem(theme.spacing[400])};
		padding-right: ${pxToRem(theme.spacing[400])};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
			padding-left: ${pxToRem(theme.spacing[500])};
			padding-right: ${pxToRem(theme.spacing[500])};
		}
	`}

	${$withHorizontalSpacing === 'right-gutter' &&
    css `
		padding-right: ${pxToRem(ICON_SIZES.md + Number(theme.spacing[200]))};
	`}
`;
export const StyledReceiptGroup = styled.div `
	${receiptGroupStyles}
`;
